(function () {
	const BREAKPOINT = 750;

	const initIconWithTextSliders = () => {
		const sections = Array.from(
			document.querySelectorAll(".icon-with-text.icon-with-text-slider")
		);
		if (sections.length === 0) return;
		sections.forEach((section) => {
			if (section.dataset.sliderBound === "true") return;
			section.dataset.sliderBound = "true";

			const sectionId = section.dataset.id;
			const perRow = +section.dataset.perRow;
			const mobileR = +section.dataset.mobile;
			const gap = +section.dataset.gap || 0;
			const speed = section.dataset.speed * 1000;
			const autoplay = toBoolean(section.dataset.autoplay);
			const enableNavigation = toBoolean(section.dataset.navigation);
			const stopAutoplayOnHover = toBoolean(section.dataset.stopAutoplay);
			const desktopEnabled = toBoolean(section.dataset.sliderDesktop);
			const mobileEnabled = toBoolean(section.dataset.sliderMobile);

			const wrapperEl = section.querySelector(".swiper-wrapper");
			if (!wrapperEl) return;
			// Loop mode moves the real slide elements around in the DOM while
			// it runs (Swiper 9+ has no clones), so remember the authored
			// order to put the static grid fallback back together after a
			// destroy() at the non-slider breakpoint.
			const authoredOrder = Array.from(wrapperEl.children);

			const mq = window.matchMedia(`(min-width: ${BREAKPOINT}px)`);
			let swiperInstance = null;

			// "Stop autoplay on hover/touch" for a continuous marquee: freeze
			// the wrapper at its exact current position (read from the live
			// computed transform, mid-transition) and halt autoplay. On
			// release, finish the interrupted leg manually from the frozen
			// spot at the marquee's normal velocity, and only hand control
			// back to autoplay once the wrapper sits exactly on a slide
			// boundary — restarting autoplay mid-leg would visibly snap to
			// the boundary, because slideNext's loopFix repositions with an
			// instant slideTo.
			//
			// freeze/resume are defined here (before build()/sync() ever run)
			// and attached to each Swiper instance from inside build() —
			// they have to exist before the first build() call since build()
			// references them, and build() runs synchronously below via the
			// first sync().
			const swiperEl = section.querySelector(".swiper");
			let freeze = null;
			let resume = null;
			if (autoplay && stopAutoplayOnHover && swiperEl) {
				let pendingResume = null;
				const cancelPendingResume = () => {
					if (pendingResume) {
						wrapperEl.removeEventListener("transitionend", pendingResume);
						pendingResume = null;
					}
				};

				freeze = () => {
					if (!swiperInstance) return;
					cancelPendingResume();
					swiperInstance.autoplay.stop();
					swiperInstance.setTranslate(swiperInstance.getTranslate());
					swiperInstance.setTransition(0);
					// Killing the transition mid-flight fires transitioncancel,
					// not transitionend, so Swiper's `animating` flag would stay
					// true forever — and in loop mode loopPreventsSliding makes
					// every later slideNext() refuse while "animating", which
					// silently blocks any restart.
					swiperInstance.animating = false;
				};

				resume = () => {
					if (!swiperInstance) return;
					const sw = swiperInstance;
					const target = -sw.snapGrid[sw.snapIndex];
					const remaining = Math.abs(target - sw.translate);
					if (remaining < 1) {
						sw.autoplay.start();
						return;
					}
					// Scale the duration so the finishing leg moves at the same
					// px/ms velocity as a full slide leg.
					const grid = sw.snapGrid;
					let step =
						sw.snapIndex > 0
							? Math.abs(grid[sw.snapIndex] - grid[sw.snapIndex - 1])
							: grid.length > 1
								? Math.abs(grid[1] - grid[0])
								: 0;
					if (!step) step = sw.size;
					const duration = Math.max(50, (speed * remaining) / step);
					pendingResume = (ev) => {
						if (ev.target !== wrapperEl) return;
						cancelPendingResume();
						if (swiperInstance) swiperInstance.autoplay.start();
					};
					wrapperEl.addEventListener("transitionend", pendingResume);
					sw.slideTo(sw.activeIndex, duration, true, true);
				};

				// Mouse: freeze on hover, resume on hover-out.
				swiperEl.addEventListener("pointerenter", (e) => {
					if (e.pointerType !== "mouse") return;
					freeze();
				});
				swiperEl.addEventListener("pointerleave", (e) => {
					if (e.pointerType !== "mouse") return;
					resume();
				});
			}

			const build = () => {
				if (swiperInstance) return;
				const params = {
					// The Liquid template guarantees enough slides (via block
					// duplication) for loop to actually engage; without loop,
					// continuous autoplay ping-pongs between the two ends.
					loop: true,
					longSwipesRatio: 0.1,
					slidesPerView: mobileR,
					spaceBetween: gap,
					allowTouchMove: true,
					speed: speed,
					breakpoints: {
						[BREAKPOINT]: {
							slidesPerView: perRow,
						},
					},
				};
				if (autoplay) {
					// pauseOnMouseEnter is deliberately NOT used: it skips the
					// pause while a transition is running, and a delay:0 marquee
					// is always mid-transition, so it would only take effect at
					// the next slide boundary (up to `speed` seconds later).
					// Hover-pause is implemented above as an instant freeze.
					params.autoplay = {
						delay: 0,
						disableOnInteraction: false,
					};
				}
				swiperInstance = new Swiper(`#${sectionId} .swiper`, params);
				// Touch: there's no hover state, so freeze/resume around the
				// drag itself, hooked through Swiper's own touchStart/touchEnd
				// events (not raw DOM pointerdown) — a DOM listener added
				// after construction fires after Swiper has already read the
				// still-animating position as its drag-start reference, so
				// the drag ends up computed against a stale offset. Swiper's
				// own events fire at the correct point in its internal
				// pipeline instead.
				if (freeze) swiperInstance.on("touchStart", freeze);
				if (resume) swiperInstance.on("touchEnd", resume);
			};

			const teardown = () => {
				if (!swiperInstance) return;
				swiperInstance.destroy(true, true);
				swiperInstance = null;
				authoredOrder.forEach((el) => wrapperEl.appendChild(el));
			};

			const sync = () => {
				if (!section.isConnected) {
					mq.removeEventListener("change", sync);
					return;
				}
				const wantSlider = mq.matches ? desktopEnabled : mobileEnabled;
				if (wantSlider) {
					build();
				} else {
					teardown();
				}
			};

			sync();
			mq.addEventListener("change", sync);

			if (enableNavigation) {
				const nextButton = section.querySelector(".multicolumn-button-next");
				const prevButton = section.querySelector(".multicolumn-button-prev");
				if (nextButton) {
					nextButton.addEventListener(
						"click",
						function () {
							if (swiperInstance) swiperInstance.slideNext(1000);
						},
						false
					);
				}
				if (prevButton) {
					prevButton.addEventListener(
						"click",
						function () {
							if (swiperInstance) swiperInstance.slidePrev(1000);
						},
						false
					);
				}
			}
		});
	};

	function toBoolean(string) {
		return string === "true" ? true : false;
	}

	document.addEventListener("DOMContentLoaded", function () {
		initIconWithTextSliders();
		document.addEventListener("shopify:section:load", initIconWithTextSliders);
	});
})();
